import { Card, Col, Descriptions, Flex, Row, Spin, Tag, Dropdown } from "antd";
import {
  UserOutlined,
  CheckCircleOutlined,
  LoadingOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import useTemplateList from "../entity/api/template-list";
import { useNavigate } from "react-router-dom";

const { Item } = Descriptions;

export default function TemplateList() {
  const navigate = useNavigate();
  const { data, isLoading, error } = useTemplateList();
  if (isLoading)
    return (
      <Flex align="center" justify="center">
        <Spin indicator={<LoadingOutlined spin />} size="large" />
      </Flex>
    );

  if (error)
    return (
      <Flex align="center" justify="center">
        <div>Error: {error.message}</div>
      </Flex>
    );

  const descriptionItems = [
    {
      icon: <UserOutlined />,
      label: "Template Owner",
      valueKey: "templateOwner",
    },
    { icon: <CheckCircleOutlined />, label: "Interval", valueKey: "interval" },
  ];

  const handleMenuClick = ({ key }, template) => {
    if (key === "edit") {
    } else if (key === "import") {
      navigate("/create-workflow", { state: template });
    } else if (key === "delete") {
    }
  };

  const menuItems = [
    {
      label: "Edit",
      key: "edit",
    },
    {
      label: "Import",
      key: "import",
    },
    {
      type: "divider",
    },
    {
      label: "Delete",
      key: "delete",
      danger: true,
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {data?.map((template) => (
        <Col key={template?.templateId || Math.random()} span={8}>
          <Card
            loading={isLoading}
            title={template?.templateName}
            extra={
              <Flex align="center" gap="small">
                <Tag color="green">{template?.frequency}</Tag>
                <Dropdown
                  menu={{
                    items: menuItems,
                    onClick: (info) => handleMenuClick(info, template),
                  }}
                  trigger={["click"]}
                >
                  <MoreButton />
                </Dropdown>
              </Flex>
            }
          >
            <Descriptions layout="vertical" column={2}>
              {descriptionItems.map(({ icon, label, valueKey }) => (
                <Item
                  key={valueKey}
                  label={<IconWithLabel icon={icon} label={label} />}
                >
                  <StyledItem>{template?.[valueKey] || "-"}</StyledItem>
                </Item>
              ))}
            </Descriptions>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

const IconWithLabel = ({ icon, label }) => (
  <Flex align="center">
    <IconWithBox>{icon}</IconWithBox>
    <div>{label}</div>
  </Flex>
);

const IconWithBox = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #f5ad1d;
  color: white;
  padding: 4px;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 16px;
`;

const StyledItem = styled.div`
  padding-left: 28px;
`;

const MoreButton = styled(MoreOutlined)`
  font-size: 20px;
  cursor: pointer;
  color: #888;

  &:hover {
    color: #1890ff;
  }
`;
